<template>
  <v-container
    id="renewalSummary"
  >
    <v-progress-linear
      v-show="loading"
      indeterminate
      color="green"
    />
    <div>
      <div class="oe-summary-title">
        <v-btn
          class="mx-2"
          fab
          dark
          x-small
          :color="approvals.color"
          @click="displaySection = !displaySection"
        >
          <v-icon
            v-show="!displaySection"
            dark
          >
            mdi-arrow-expand-vertical
          </v-icon>
          <v-icon
            v-show="displaySection"
            dark
          >
            mdi-arrow-expand-horizontal
          </v-icon>
        </v-btn>
        Renewal Summary
      </div>
      <div
        v-if="!loading && renewals && renewals.length"
      >
        <div
          v-for="(renewal, i) in renewals"
          :key="i"
        >
          <v-fab-transition>
            <div
              v-show="displaySection"
              class="oe-summary-subsection mt-6"
            >
              <div class="text-center display-1">
                {{ renewal.renewal }}
              </div>
              <v-row
                v-if="renewal.manuallyAdded"
              >
                <v-col
                  cols="6"
                >
                  <div
                    class="font-weight-bold green--text"
                  >
                    <v-icon
                      color="green"
                      medium
                    >
                      mdi-plus-circle-multiple
                    </v-icon>
                    New Plan
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.product"
                    label="Product"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.carrier"
                    label="Carrier"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.change"
                    label="Carrier Change"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.rateChange"
                    label="Rate Change"
                    data-type="boolean"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  &nbsp;
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.newPlanOffering"
                    label="New Plan Offering"
                    data-type="boolean"
                  />
                </v-col>
              </v-row>
              <!-- v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.newHireGIRules"
                    label="New Hire GI Rules"
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.lateEntrantGIRules"
                    label="Late Entrant GI Rules"
                  />
                </v-col>
                <v-col cols="6">
                  <base-display-value
                    v-model="renewal.increasesToExistingGIRules"
                    label="Increases To Existing GI Rules"
                  />
                </v-col>
              </v-row -->
            </div>
          </v-fab-transition>
        </div>
      </div>
      <v-fab-transition>
        <v-alert
          v-show="displaySection && (!loading && (!renewals || !renewals.length))"
          type="info"
        >
          No renewal details found
        </v-alert>
      </v-fab-transition>
      <v-fab-transition>
        <approval
          v-show="displaySection"
          :approvals="approvals"
          :allow-change="!print"
          @approval:changed="$emit('approval:changed')"
        />
      </v-fab-transition>
    </div>
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'
  import Approvals from '@/services/troody/Approvals'

  export default {
    name: 'RenewalSummary',

    components: {
      Approval: () => import('./Approval'),
    },

    props: {
      expanded: {
        type: Boolean,
        default: false,
      },
      openEnrollment: {
        type: Object,
        default: null,
      },
      print: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      displaySection: true,

      loadingRenewal: false,

      errorMessage: null,
      displayError: false,
      formErrors: {},

      renewals: null,

      renewalResource: new TroodyApi('oeRenewal/'),
      approvals: null,
    }),

    computed: {
      loading () {
        return (this.loadingRenewal)
      },
    },

    watch: {
      expanded (val) {
        this.displaySection = val
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadRenewal()
        this.approvals = new Approvals(this.openEnrollment.id, Approvals.sections.renewal.id)
        this.displaySection = this.expanded
      },

      loadRenewal () {
        this.loadingRenewal = true
        this.renewalResource.query({ openEnrollmentId: this.openEnrollment.id })
          .then(data => {
            console.log('renewal')
            console.log(data)
            this.loadingRenewal = false
            this.renewals = data
          })
          .catch((error) => {
            this.loadingRenewal = false
            this.renewals = null
            this.showError(error, 'Failed to load renewal details!')
          })
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
